import './footer.scss';
import { useLayoutContext } from '../../context/game';
import { useState } from 'react';
import Modal from '../modal';
export default function Footer() {
	const isProd = !window.location.search.includes('builder') && !window.builder;
	const year = new Date(Date.now()).toISOString().substr(0, 4);
	const [context, setContext] = useLayoutContext();

	return (
		<footer className='footer-wrap'>
			{context?.route === 'questions' && <WheelFooter />}
			{isProd && (
				<div className="page-footer">
					<div className="container">
						© Valstybės pažinimo centras Lietuvos Respublikos Prezidento kanceliarija, {year}. Visos teisės saugomos.
					</div>
				</div>
			)}
		</footer>
	)

	function WheelFooter() {
		const [modalOpen, setModalOpen] = useState(false);
		const helpContent = window.global_data?.help?.content || null;

		const onClickReset = () => {
			setContext({ disabled: [] });
		}
		return (
			<div className="game-footer">
				<div className="container">
					<hr />
					<button className='footer-btn' onClick={onClickReset}>
						<svg className='me-3' width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M20.3444 21.0804C18.1669 22.9672 15.3812 24.004 12.5 24C5.8724 24 0.5 18.6276 0.5 12C0.5 5.3724 5.8724 0 12.5 0C19.1276 0 24.5 5.3724 24.5 12C24.5 14.5632 23.696 16.9392 22.328 18.888L18.5 12H22.1C22.0998 9.78744 21.3354 7.64287 19.936 5.92907C18.5366 4.21526 16.5882 3.03743 14.4204 2.59483C12.2526 2.15223 9.99839 2.47202 8.03921 3.50012C6.08003 4.52821 4.53611 6.20149 3.66863 8.23689C2.80115 10.2723 2.66337 12.5449 3.27859 14.6702C3.89381 16.7955 5.22427 18.643 7.0449 19.9003C8.86552 21.1575 11.0645 21.7473 13.27 21.5699C15.4754 21.3924 17.5518 20.4586 19.148 18.9264L20.3444 21.0804Z" fill="currentColor" />
						</svg>
						Bandyti iš naujo
					</button>
					{helpContent && (
						<button className='footer-btn' onClick={() => { setModalOpen(true) }}>
							<svg className="me-3" width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M6 17C6.828 17 7.5 17.672 7.5 18.5C7.5 19.328 6.828 20 6 20C5.172 20 4.5 19.328 4.5 18.5C4.5 17.672 5.172 17 6 17ZM6 0C9.314 0 12 2.686 12 6C12 8.165 11.247 9.29 9.326 10.923C7.399 12.56 7 13.297 7 15H5C5 12.526 5.787 11.305 8.031 9.399C9.548 8.11 10 7.434 10 6C10 3.79 8.21 2 6 2C3.79 2 2 3.79 2 6V7H0V6C0 2.686 2.686 0 6 0Z" fill="currentColor" />
							</svg>

							Pagalba
						</button>
					)}

					{modalOpen && <Modal content={helpContent} setOpen={setModalOpen} />}
				</div>
			</div>
		)
	}



}